import PhoneIcon from '@mui/icons-material/Phone';

import { useI18n } from '@openclassrooms/translations/I18nProvider';

import ContactChannelButton from './ContactChannelButton';

export default function ContactChannelButtonPhone({ onClick }: { onClick: () => void }) {
  const { translate } = useI18n();

  return (
    <ContactChannelButton iconComponent={PhoneIcon} onClick={onClick}>
      {translate('support.global.contact_channel.call.title')}
    </ContactChannelButton>
  );
}
